export default __webpack_public_path__ + "static/media/position-status-2.0e408727.svg";